// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__33lpa","icon":"Error_icon__3ZjoS"};